import { Component, OnInit } from '@angular/core';
import { SupportService } from '../rest_services/msHelpServices/support.service';
import { UserService } from '../rest_services/user.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  ticketsLoading: boolean = true;
  alltickets :any[] = [];
  

  constructor(
    private supportService: SupportService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.loadTickets();
  }

  loadTickets() {
    this.ticketsLoading = true;
    this.supportService.getRequestList();
    this.supportService.requestListSubject.subscribe(
      (response: any) => {
        this.ticketsLoading = false;
        if (response.status === '200') {
          this.alltickets = response.data;     
          this.fetchCreator();
          this.fetchRequestor();
          this.initializeDatDatble();
        } else {
          this.initializeDatDatble();
          console.error('Failed to load tickets');
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
        this.ticketsLoading = false;
      }
    );
  }
  fetchCreator() {
    this.alltickets.forEach((ticket: any) => {
      const userId = ticket.createdBy; // Assuming userId is the user UUID
      this.userService.getUserFilteredData(userId, ['fullName']).subscribe(
        (userData: any) => {
          if (userData) {
            ticket.creator = userData.connected_user.user_fullname;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }

  fetchRequestor() {
    this.alltickets.forEach((ticket: any) => {
      const userId = ticket.requestedBy; // Assuming userId is the user UUID
      this.userService.getUserFilteredData(userId, ['fullName']).subscribe(
        (userData: any) => {
          if (userData) {
            ticket.requestor = userData.connected_user.user_fullname;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }
  initializeDatDatble(){
    setTimeout(() => {
      (<any>$("#alter_pagination")).DataTable( {
        "destroy":true,
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "scrollCollapse": true,
        aaSorting: false, 
        "iDisplayLength": 25,
        // columnDefs: [ { type: 'string', 'targets': [0], "orderable": true } ],
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                type: 'line',
                width: '60',
                height: '20',
                lineColor: '#1a73e9',
                fillColor: '#c2d5ff',
                spotColor: 'transparent',
                minSpotColor: 'transparent',
                maxSpotColor: 'transparent',
                highlightSpotColor: 'transparent',
                highlightLineColor: 'transparent',
            });
        }
      });
    }, 1000);
  }
}
